import $ from 'jquery';

export default class Enquiry {
  constructor() {
    // Preparing default values
    const keywordValue = window.localStorage.getItem('keywords');
    const zipValue = window.localStorage.getItem('zipCode');
    const $lastSearchKeyword = $('#lastSearchKeyword');
    const $lastSearchSuburb = $('#lastSearchSuburb');

    if ($lastSearchKeyword.length && keywordValue && keywordValue.length) {
      $lastSearchKeyword.val(keywordValue);
    }

    if ($lastSearchSuburb.length && zipValue && zipValue.length) {
      $lastSearchSuburb.val(zipValue);
    }

    $('#user_agent').val(window.navigator.userAgent);
    $('#origin_url').val(top === self
      // if this is parent frame already use the referrer's url
      ? document.referrer
      // else this is in iframe, then use the parent's url
      : parent.document.URL
    );

    // Enabling submit on validation error
    window.Parsley.on('form:error', ({ $element }) => {
      if ($element.hasClass('enquiry-form')) {
        $element.find('[disabled="true"], [disabled]').removeAttr('disabled');
      }
    });

    // Generating the body
    $('.enquiry-form').on('submit', function () {
      const $this = $(this);
      const $emailInput = $this.find('[name="email"]');
      const $aTimeInput = $this.find('[name="appointment_time"]');
      const $minuteInput = $this.find('#minute');
      const $hourInput = $this.find('#hour');
      const $ampmInput = $this.find('#ampm');
      const $clientInput = $this.find('[name="client"]');
      const $typeInput = $this.find('[name="type"]');
      const optional = [
        { name: 'state', label: 'State: ' },
        { name: 'title', label: 'Title: ' },
        { name: 'service_type', label: 'Service Type: ' },
        { name: 'address', label: 'Address: ' },
        { name: 'postcode', label: 'Postcode: ' },
        { name: 'state', label: 'State: ' },
        { name: 'country', label: 'Country: ' },
        { name: 'study_preference', label: 'Study Preference: ' },
        { name: 'preferred_study_mode', label: 'Preferred study mode: ' },
        { name: 'preferred_contact_time', label: 'When should we contact you? ' },
        { name: 'interest_area', label: 'Area of interest: ' },
        { name: 'appointment_date', label: 'Date of appointment requested: ' },
        { name: 'appointment_time', label: 'Time of appointment requested: ' }
      ];
      let cBody;

      // Disabling submit
      $this.find('[type="submit"]').attr('disabled', 'disabled');

      // Transforming time
      if ($aTimeInput.length && $hourInput.length) {
        // Compose the time from the three select boxes (only for desktop as mobile has an input time)
        if ($hourInput.val() && $minuteInput.val() && $ampmInput.val()) {
          $aTimeInput.val(`${$hourInput.val()}:${$minuteInput.val()}${$ampmInput.val()}`);
        }
      }

      cBody = `Dear ${$clientInput.val()} ${$typeInput.val() === 2 ? 'Make an Appointment' : 'Question:'}\n`;
      cBody += `\tName: ${$('[name="full_name"]').val()}\n`;
      cBody += `\tEmail: ${$emailInput.val()}\n`;
      cBody += `\tContact Phone: ${$('[name="phone"]').val()}\n`;

      optional.forEach(({ name, label }) => {
        const $input = $(`[name="${name}"]`);
        if ($input.length) {
          const value = $input.val().trim();
          if (value) {
            cBody += `\t${label} ${value}\n`;
          }
        }
      });

      cBody += `\n\tMessage: ${$('[name="message"]').val()}\n\n`;
      cBody += `This email was intended for ${$('[name="company"]').val()}\n`;

      $this.find('[name="From"]').val($emailInput.val().trim());
      $this.find('[name="Body"]').val(cBody);
    });
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/enquiry.js